// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../hooks/useBlogAPI";
import { Modal, Button } from "antd";

const AuthContext = createContext();

export const useGlobalAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useGlobalAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const { user, loading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const requireAuth = (action) => {
    if (!user) {
      setPendingAction(action);
      setShowAuthModal(true);
      return false;
    }
    return true;
  };

  const handleGoToLogin = () => {
    window.location.href = "/auth";
    setShowAuthModal(false);
  };

  const handleCancel = () => {
    setShowAuthModal(false);
    setPendingAction(null);
  };

  useEffect(() => {
    if (user && pendingAction) {
      // 用户登录后执行之前被阻止的操作
      pendingAction();
      setPendingAction(null);
    }
  }, [user, pendingAction]);

  return (
    <AuthContext.Provider value={{ requireAuth, user, loading }}>
      {children}
      <Modal
        title="需要登录"
        open={showAuthModal}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            取消
          </Button>,
          <Button key="login" type="primary" onClick={handleGoToLogin}>
            去登录
          </Button>,
        ]}
      >
        <p>您需要先登录才能执行此操作。</p>
      </Modal>
    </AuthContext.Provider>
  );
};
